export const isHtml = (s) => typeof s === "string" && /<\/?(p|br|strong|em|s|u|a|ul|ol|li|h2|h3|blockquote|mark|label|input|div|span)\b/i.test(s);

const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
export const toHtml = (s) => (!s ? "" : isHtml(s) ? s : s.split(/\n/).map((l) => `<p>${esc(l)}</p>`).join(""));

export function plainText(s) {
  if (!s || !isHtml(s)) return s || "";
  // DOMParser documents are inert (no scripts or image loads), so this is safe for untrusted HTML.
  const doc = new DOMParser().parseFromString(s.replace(/<\/(p|li|h2|h3|blockquote)>/gi, "$& ").replace(/<br\s*\/?>/gi, " "), "text/html");
  return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
}
